import React from "react";
import Select, { StylesConfig, OptionsOrGroups, GroupBase, components } from "react-select";
import fireIcon from "../../assets/icons/fire.svg";
import { Loader } from "@thdinc/hpf-shared";

type OptionType = {
    label: string;
    value: string;
};
interface StyledSelectProps {
    options: OptionsOrGroups<OptionType, GroupBase<OptionType>>;
    value: OptionType | undefined;
    onChange: (value: any) => void;
    placeholder?: string;
    isCustomComponent?: boolean;
    preferedProduct?: any[];
    isLoading?: boolean;
}
const customStyles: StylesConfig<OptionType, false> = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: '#f7f8fa',
        borderRadius: '9999px',
        minHeight: '49px',
        paddingLeft: '14px',
        border: "none",
        boxShadow: state.menuIsOpen ? "0 0 0 1px #FF5100" : "none",
        "&:hover": {
            border: 'none'
        },
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4B5563',
    }),
    dropdownIndicator: () => ({
        display: "none",
    }),
    indicatorSeparator: () => ({
        display: "none",
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? "white" : "white",
        color: state.isSelected ? "#484858" : "#4B5563",
        fontWeight: state.isSelected ? "bolder" : "normal",
        fontSize: state.isSelected ? "13.5px" : "14px",
        padding: "10px 16px",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: state.isSelected ? "#E2E8F0" : "#F3F4F6",
        },
    }),
    menuList: (provided) => ({
        ...provided,
        padding: 0,
        maxHeight: "180px",
        overflowY: "auto",
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#9ca3b5',
        fontFamily: "YourFont, sans-serif",
        fontWeight: 500,
        fontSize: 14
    })
};
const createSingleValue = (preferedProduct: any[] = []) => {
    const SingleValueComponent = (props: any) => {
        let preferenceLabel = '';
        for (const product of preferedProduct) {
            if (product.prefer1?.id === props.data.value) {
                preferenceLabel = 'Preferred One';
                break;
            } else if (product.prefer2?.id === props.data.value) {
                preferenceLabel = 'Preferred Two';
                break;
            } else if (product.prefer3?.id === props.data.value) {
                preferenceLabel = 'Preferred Three';
                break;
            }
        }
        return (
            <components.SingleValue {...props}>
                <div className="flex flex-row items-center gap-1 max-w-[190px]">
                    <span className={`truncate overflow-hidden whitespace-nowrap ${preferenceLabel && 'text-[14px] text-primary-red'}`}>
                        {props.data.label}
                    </span>
                    {preferenceLabel == 'Preferred One' &&
                        <span className="text-primary-red flex flex-row items-center text-[14px]">
                            {/* <img src={fireIcon} className="w-3 h-5" /> */}
                            {`(Preferred)`}
                        </span>
                    }
                </div>
            </components.SingleValue>
        );
    };
    SingleValueComponent.displayName = "CustomSingleValue";
    return SingleValueComponent;
};
const createOption = (preferedProduct: any[] = []) => {
    const OptionComponent = (props: any) => {
        let preferenceLabel = '';

        for (const product of preferedProduct) {
            if (product.prefer1?.id === props.data.value) {
                preferenceLabel = 'Preferred One';
                break;
            } else if (product.prefer2?.id === props.data.value) {
                preferenceLabel = 'Preferred Two';
                break;
            } else if (product.prefer3?.id === props.data.value) {
                preferenceLabel = 'Preferred Three';
                break;
            }
        }

        return (
            <components.Option {...props}>
                <div className="flex items-center justify-between">
                    <span className={`${preferenceLabel && 'text-primary-red'}`}>{props.data.label}</span>
                    {preferenceLabel == 'Preferred One' && (
                        <span className="text-xs text-primary-red flex flex-row items-center gap-1">
                            {/* <img src={fireIcon} className="w-3 h-5" /> */}
                            {`(Preferred)`}
                        </span>
                    )}
                </div>
            </components.Option>
        );
    };

    OptionComponent.displayName = "CustomOption";

    return OptionComponent;
};

const StyledSelect: React.FC<StyledSelectProps> = ({ options, value, onChange, placeholder, isCustomComponent, preferedProduct, isLoading }) => {
    const isProductLoading = isLoading ? isLoading : false;
    return (
        <Select
            options={options}
            value={value ?? null}
            onChange={onChange}
            placeholder={placeholder}
            styles={customStyles}
            isLoading={isProductLoading}
            components={
                isCustomComponent
                    ? {
                        SingleValue: createSingleValue(preferedProduct || []),
                        Option: createOption(preferedProduct || []),
                        LoadingMessage: () => (
                            <div className="flex items-center justify-center py-2">
                                <Loader color="bg-red-500" />
                            </div>
                        ),
                        LoadingIndicator: () => null
                    }
                    : undefined
            }
        />
    );
};

export default StyledSelect;